"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MomentTitle = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _atoms = require("../atoms");

var _MomentRow = require("./MomentRow");

var _ = require("..");

require("./MomentTitle.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: =, Brian Bal
 */

/*
 * This component will display a title like view for a moment,
 * it is meant to be displayed on top of video but can be
 * displayed anywhere.
 */
var MomentTitle = function MomentTitle(props) {
  var _props$highlightPlaye, _props$moment3, _props$moment3$source;

  var avatarsKlass = "none";

  if (props.players && props.players.length < 6 && props.players.length > 0) {
    avatarsKlass = "short";
  } else if (props.players && props.players.length > 5) {
    avatarsKlass = "tall";
  }

  var tagsKlass = "";

  if (!props.players || props.players.length === 0) {
    tagsKlass = "only-tags";
  } else if (props.players.length === 1) {
    tagsKlass = "single";
  } else if (props.players.length === 2) {
    tagsKlass = "double";
  } else {
    tagsKlass = "multi";
  }

  var playlist = props.playlist ? props.playlist : "--";
  var playlistTitle = "";

  if (((_props$highlightPlaye = props.highlightPlayer) === null || _props$highlightPlaye === void 0 ? void 0 : _props$highlightPlaye.jersey_number) === "" || props.highlightPlayer === null) {
    var _props$moment;

    playlistTitle = "".concat(playlist, " ").concat((_props$moment = props.moment) !== null && _props$moment !== void 0 && _props$moment.display_number ? props.moment.display_number : 1, "/").concat(props.momentCount);
  } else {
    var _props$moment2;

    playlistTitle = "#".concat(props.highlightPlayer.jersey_number, " ").concat(playlist, " ").concat((_props$moment2 = props.moment) !== null && _props$moment2 !== void 0 && _props$moment2.display_number ? props.moment.display_number : 1, "/").concat(props.momentCount);
  }

  var formatClipViews = function formatClipViews(noOfViews) {
    if (noOfViews) {
      var noOfViewsFormatted = noOfViews.toLocaleString();
      return "".concat(noOfViewsFormatted, " Moment ").concat(noOfViews !== 1 ? "views" : "view");
    } else {
      return "Counting moment views...";
    }
  };

  var sourceCount = (_props$moment3 = props.moment) !== null && _props$moment3 !== void 0 && (_props$moment3$source = _props$moment3.sources) !== null && _props$moment3$source !== void 0 && _props$moment3$source.length ? props.moment.sources.length + 1 : 0;
  return /*#__PURE__*/_react.default.createElement(_atoms.Element, {
    className: "MomentTitle"
  }, /*#__PURE__*/_react.default.createElement(_atoms.Column, null, /*#__PURE__*/_react.default.createElement(_atoms.Row, null, /*#__PURE__*/_react.default.createElement(_atoms.Label, {
    className: "moment-title-clip-views",
    type: _atoms.Label.Type.Body,
    content: formatClipViews(props.clipViews),
    marginBottom: "4",
    color: _atoms.Color.White2
  }), /*#__PURE__*/_react.default.createElement(_.InfoTooltip, {
    buttonColor: _atoms.Color.White2,
    marginRight: "3",
    open: true,
    content: /*#__PURE__*/_react.default.createElement(_atoms.Label, null, /*#__PURE__*/_react.default.createElement("strong", null, "Moment views"), " is the total moment views for this game.", /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("br", null), " Any time someone watches one of the moments from this game, that view gets added to the", /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("strong", null, "Moment views"), " total. All playlists associated with your game are included in this view count.")
  })), props.moment && /*#__PURE__*/_react.default.createElement(_atoms.Element, {
    className: "moment-title-playlist-wrapper",
    marginBottom: "4",
    onClick: props.onCheveronClick,
    content: /*#__PURE__*/_react.default.createElement(_atoms.Row, null, /*#__PURE__*/_react.default.createElement(_atoms.Label, {
      className: "moment-title-playlist",
      type: _atoms.Label.Type.Heading4,
      color: _atoms.Color.White2,
      content: playlistTitle
    }), /*#__PURE__*/_react.default.createElement(_atoms.Icon, {
      size: "24",
      type: _atoms.Icon.Type.CheveronDown,
      color: _atoms.Color.White2
    }))
  }), /*#__PURE__*/_react.default.createElement(_atoms.Row, {
    marginBottom: "4"
  }, /*#__PURE__*/_react.default.createElement(_MomentRow.MomentAvatars, {
    name: avatarsKlass,
    avatarSize: props.avatarSize,
    players: props.players,
    marginBottom: "2",
    onAvatarClick: props.onAvatarClick
  }), /*#__PURE__*/_react.default.createElement(_MomentRow.MomentTags, {
    name: "tags ".concat(tagsKlass),
    tags: (0, _.generateHumanTags)(props.moment),
    homeColor: props.homeColor,
    awayColor: props.awayColor,
    sourceCount: sourceCount,
    active: true
  }))));
};

exports.MomentTitle = MomentTitle;
MomentTitle.propTypes = {
  /* The moment that you want to display */
  moment: _propTypes.default.shape({
    duration: _propTypes.default.number,
    half: _propTypes.default.number,
    time: _propTypes.default.number,
    utc_time: _propTypes.default.number,
    game_clip_id: _propTypes.default.number,
    game_id: _propTypes.default.number,
    team_id: _propTypes.default.number,
    user_playlist_key: _propTypes.default.string,
    dynamic: _propTypes.default.shape({
      audio: _propTypes.default.string,
      duration: _propTypes.default.number,
      hls: _propTypes.default.string,
      jfile: _propTypes.default.string,
      offset: _propTypes.default.number,
      start: _propTypes.default.number
    }),
    meta: _propTypes.default.shape({
      all_trace_numbers: _propTypes.default.array,
      thirds: _propTypes.default.array,
      trace_numbers: _propTypes.default.array,
      type: _propTypes.default.string,
      uuid: _propTypes.default.string
    })
  }),

  /* Array of players to show for this moment */
  players: _propTypes.default.array,

  /* User id of the player to highlight in this title */
  highlightPlayer: _propTypes.default.number,

  /* When true the hightlight player will have a Color.Sky border */
  spotlight: _propTypes.default.bool,

  /* Array of tags to show for this moment */
  tags: _propTypes.default.array,

  /* Playlist title to show for this moment */
  playlist: _propTypes.default.string,

  /* Avatar on click handler */
  onAvatarClick: _propTypes.default.func,

  /* Avatar size */
  avatarSize: _propTypes.default.number,

  /* When true Add tags button will be shown */
  showAddTagsButton: _propTypes.default.bool,

  /* Cheveron down on click handler */
  onCheveronClick: _propTypes.default.func
};